import { api } from "../lib/api";

// myntraFashionService — real Myntra product retrieval (via backend scraping provider)
export async function searchProducts(occasion, styleDirection, hairstyle, budget) {
  const { data } = await api.post("/ai/myntra-search", { occasion, styleDirection, hairstyle, budget });
  return data; // { status: 'ok'|'no_products', queries[], products[] }
}

// Metadata helper used to populate cards + drive the final look
export function getProductMetadata(product) {
  return {
    image: product.image,
    url: product.url,
    title: product.title,
    brand: product.brand,
    price: product.price,
    rating: product.rating,
  };
}
